import { ICollaborationMetadata } from '@cscglobal-tbs/collaboration-ui';
import { useCommentTitleGeneration } from './useCommentTitleGeneration';

export const useReportCommentsMetadata = (reportId?: string, reportName?: string): ICollaborationMetadata => {
    const { newConversationTitle } = useCommentTitleGeneration(reportId);

    return {
        contextData: {
            reportId,
            reportName,
        },
        generateNewConversationTitle: () => newConversationTitle,
    };
};
